import type {Insight} from "../../../models/api/insight/Insight";
import {InsightTypeEnum} from "../../../models/api/insight/InsightTypeEnum";
import {KategorieEnum} from "../../../models/api/insight/KategorieEnum";
import {LizenzEnum} from "../../../models/api/insight/LizenzEnum";
import {AktionTypeEnum} from "../../../models/api/insight/AktionTypeEnum";

const insights: Array<Insight> = [
    {
        id: "20260904-zusatzfuehrerscheine",
        datum: "04.09.2026",
        kategorie: KategorieEnum.DESKTOP,
        type: InsightTypeEnum.VERBESSERTES_FEATURE,
        title: "Update Zusatzführerscheine",
        lizenz: [LizenzEnum.PRO, LizenzEnum.KURSE],
        content: [
            "⚙️ Für die 3 benutzerdefinierten Fahrerlaubnisklassen"
            + " (System → Einstellungen → Gruppen / Mitgliederliste) können nun eigene Kürzel hinterlegt werden."
        ],
        aktions: [],
    },
    {
        id: "20260904-gemeinsame_dienste",
        datum: "04.09.2026",
        kategorie: KategorieEnum.DESKTOP,
        type: InsightTypeEnum.FEATURE,
        title: "Infos bei gemeinsamen Diensten",
        lizenz: [LizenzEnum.PRO],
        content: [
            "📧 Ändern sich bei einem gemeinsam durchgeführten Dienst wichtige Planungsdaten, können die beteiligten"
            + " Partner-Organisationen nun automatisch per E-Mail informiert werden. Nutzt dafür die Option „Verknüpfte"
            + " Organisation(en) informieren“ auf dem Dienstformular.",
        ],
        aktions: [
            {
                type: AktionTypeEnum.BLOG,
                text: "Details im Blog",
                url: "https://info.hiorg-server.de/2026/08/gemeinsame-dienste-partner-organisationen-informieren/",
            }
        ],
    },
    {
        id: "20260904-kurstyp",
        datum: "04.09.2026",
        kategorie: KategorieEnum.DESKTOP,
        type: InsightTypeEnum.FEATURE,
        title: "Individuelle E-Mail-Vorlagen für jeden Kurstyp",
        lizenz: [LizenzEnum.KURSE],
        content: [
            "📧 Für viele der kursbezogenen Standardmails können bei Bedarf nun eigene Varianten je Kurstyp hinterlegt"
            + " werden. Die Einstellungen findest du unter System > Einstellungen > Systemmails.",
        ],
        aktions: [
            {
                type: AktionTypeEnum.BLOG,
                text: "Details im Blog",
                url: "https://info.hiorg-server.de/2026/08/individuelle-e-mail-vorlagen-fuer-jeden-kurstyp/",
            }
        ],
    },
];

export {
    insights,
};
